const SIDE_DOCK_WIDTH = 500;
export const ANIMATION_DURATION = 500;
export const getSideDockWidth = browserWindowWidth => Math.min(SIDE_DOCK_WIDTH, browserWindowWidth);